import {
  Field,
  GraphQLJSON,
  ID,
  ObjectType,
  registerEnumType,
  removeBigIntMiddleware,
} from '@warebee/shared/util-backend-only-types';

@ObjectType()
export class DatasetObjectQueryColumn {
  @Field(() => ID)
  name: string;

  @Field(() => ID)
  type: string;
}

@ObjectType()
export class DatasetObjectQueryResponse {
  @Field(() => [DatasetObjectQueryColumn])
  columns: DatasetObjectQueryColumn[];

  @Field(() => GraphQLJSON, { middleware: [removeBigIntMiddleware] })
  result: any;
}

@ObjectType()
export class DatasetObjectQueryResponseChunk extends DatasetObjectQueryResponse {
  @Field(() => ID, { nullable: true })
  nextToken?: string;
}

export enum DatasetQueryExecutionStatus {
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
  QUEUED = 'QUEUED',
  RUNNING = 'RUNNING',
  SUCCEEDED = 'SUCCEEDED',
}

registerEnumType(DatasetQueryExecutionStatus, {
  name: 'DatasetQueryExecutionStatus',
});

@ObjectType()
export class DatasetObjectQueryAsyncResponse {
  @Field(() => ID)
  queryToken: string;

  @Field(() => DatasetQueryExecutionStatus)
  status: DatasetQueryExecutionStatus;
}
